import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ANONYMOUS_TOKEN_PATH,
  AnonymousTokenService,
} from '@core/authen/anonymous-token.service';
import {
  AuthenService,
  LOGOUT_PATH,
  REFRESH_TOKEN_PATH,
} from '@core/authen/authen.service';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthenService,
    private readonly anonymousTokenService: AnonymousTokenService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const willHandle = !/(wp-json\/wp\/v2\/media)/i.test(request.url);

    if (!willHandle || request.url.includes(ANONYMOUS_TOKEN_PATH)) {
      return next.handle(request);
    }

    if (
      request.url.includes(REFRESH_TOKEN_PATH) ||
      request.url.includes(LOGOUT_PATH)
    ) {
      return next.handle(
        this.attachToken(request, this.authService.getStoredAccessToken())
      );
    }

    const userToken = this.authService.getAccessToken();

    if (userToken) {
      return next.handle(this.attachToken(request, userToken));
    }

    return this.anonymousTokenService
      .ensureToken()
      .pipe(
        switchMap(anonymousToken =>
          next.handle(this.attachToken(request, anonymousToken))
        )
      );
  }

  private attachToken(
    request: HttpRequest<unknown>,
    token: string
  ): HttpRequest<unknown> {
    const headersConfig: Record<string, string> = {};

    const locale = request.headers.get('jip-locale');

    if (token) {
      headersConfig.Authorization = 'Bearer ' + token;
    }

    if (locale) {
      headersConfig['jip-locale'] = locale;
    }

    return request.clone({ setHeaders: headersConfig });
  }
}
